import { MutationFunction, useMutation } from '@tanstack/react-query'
import { apiClient } from '@src/services/http-common'

export interface JwtToken {
  jwt: string
}

// const signIn: MutationFunction<JwtToken, JwtToken> = async (data: JwtToken) => {
//   const response = await apiClient.post('Login/GenerateJwtToken', data)
//   return response.data as JwtToken
// }

const signIn: MutationFunction<JwtToken, { jwt: string; personId: string }> = async ({ jwt, personId }) => {
  const response = await apiClient.post(`Login/GenerateJwtToken/${personId}`, { jwt });
  return response.data as JwtToken;
}


export function useSignIn() {
  const { isPending, mutateAsync, reset } = useMutation({
    mutationFn: signIn,
  })

  return { isLoading: isPending, mutateAsync, reset }
}
// export const fetchUserData = async () => {
//   const token = localStorage.getItem('userToken');
//   if (!token) {
//       throw new Error('No token found');
//   }
  
//   const response = await apiClient.get('https://localhost:7001/api/Person', {
//       headers: { 'Authorization': `Bearer ${token}` }
//   });
//   return response.data;
// };